<template>
    <div class="ui internally grid">
        <!-- <div v-bind:class="{eight:(multi_gallery && gallery),ten:!multi_gallery,sixteen:(!gallery && !multi_gallery), twelve:(!gallery && multi_gallery) , wide:true,column:true}">-->
        <div v-bind:class="class_left" id="item_level_left">

            <div class="ui segment">
                <TheData v-bind:item="item"></TheData>
            </div>
            <div class="ui internally grid">
                <div v-if="hasOwnDeepProperty(item,'room.id')" class="ten wide column">
                    <div class="ui segment">
                        <ThePlanView v-if="!extended_plan_opened" v-bind:room_id="item.room.id" v-bind:extended="false" @openExtendedPlan="openExtendedPlan"></ThePlanView>
                    </div>
                </div>
                <div class="six wide column">
                    <span v-for="n in item.object[0].name">
                        <div v-if="n.hasOwnProperty('getty_external_id')" class="ui segment">
                
                            <TheGettyUlan v-bind:ulanid="n.getty_external_id"></TheGettyUlan>
                        </div>
                    </span>
                </div>
            </div>
        </div>

        <div v-if="!class_right.sixteen" v-bind:class="class_right" id="item_level_right">
            <TheGallery v-bind:object_list="item.object" @layout="calculateItemLayout"></TheGallery>
        </div>
        <TheSimpleModal v-if="extended_plan_opened" @closeMe="closeExtendedPlan">
            <ThePlanView v-bind:room_id="item.room.id" v-bind:extended="true"></ThePlanView>
        </TheSimpleModal>

    </div>
</template>

<script>
    import TheCarousel from './TheCarousel.vue'
    import TheIconClass from './TheIconClass.vue'
    import TheGettyUlan from './TheGettyUlan.vue'
    import TheData from './TheData.vue'
    import TheGallery from './TheGallery2.vue'
    import TheSimpleModal from './TheSimpleModal.vue'
    import ThePlanView from './ThePlanView.vue'

    export default {
        props: ['item'],
        data() {
            return {
                slides: [],
                modal_slides: [],
                gallery_opened: false,
                extended_plan_opened: false,
                related_items: null,
                class_left: {
                    sixteen: false,
                    thirteen: false,
                    eight: true,
                    wide: true,
                    column: true
                },
                class_right: {
                    three: false,
                    eight: true,
                    wide: true,
                    column: true
                },
                type: null

            }
        },


        methods: {
            calculateItemLayout: function(layout) {

                var lObj = JSON.parse(layout);
                console.log(lObj)
                if (!lObj.galleryOpened && !lObj.gallerySelectorOpened) {
                     this.class_left.eight = false
                    this.class_left.thirteen = false
                    this.class_left.sixteen = true
                    
                    this.$emit('layout', 1);
                }
                if (lObj.galleryOpened && !lObj.gallerySelectorOpened) { //tye 2 
                    this.class_left.eight = true
                    this.class_left.thirteen = false
                    this.class_left.sixteen = false
                    this.class_right.eight = true
                    this.class_right.three = false
                    this.$emit('layout', 2);
                }
                if (lObj.galleryOpened && lObj.gallerySelectorOpened) { //tye 2 
                    this.class_left.eight = true
                    this.class_left.thirteen = false
                    this.class_left.sixteen = false
                    this.class_right.eight = true
                    this.class_right.three = false
                    this.$emit('layout', 3);
                }
                if (lObj.gallerySelectorOpened && !lObj.galleryOpened) { //type 4
                    this.class_left.eight = false
                    this.class_left.thirteen = true
                    this.class_left.sixteen = false
                    this.class_right.eight = false
                    this.class_right.three = true
                    this.$emit('layout', 4);
                }

            },

            hasOwnDeepProperty: function(obj, path) {
                var arr;
                for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
                    arr = path[i].match(/(.+)\[(\d+)\]/mi);
                    if (arr != null) {
                        if (arr.length == 3) {
                            if (obj[arr[1]]) obj = obj[arr[1]][arr[2]];
                            else return false;
                        }
                    }
                    else obj = obj[path[i]];
                    if (!obj) return false;
                };
                return true;
            },
             hasOwnDeepPropertyv2: function(obj, path) {
                path = path.split('.');
                for (var i in path) {
                    if (path[i].match(/\[\d+\]/mi) == null) {
                        if (obj.hasOwnProperty(path[i])) {
                            obj = obj[path[i]];
                        }
                        else {
                            console.log("dp:false")
                            return false
                        }
                    }
                    else {
                        var matchArr = path[i].match(/\[(\d+)\]/mi);
                        obj = obj[path[i].replace(/\[\d+\]/mi, '')];
                        console.log(JSON.stringify(obj))
                        if (obj != undefined) {
                            obj = obj[matchArr[1]]
                        }
                        else {
                             console.log("dp:false")
                            return false
                        }
                    }
                }
                 console.log("dp:true")
                return true
            },
   

            closeGallery: function() {
                this.gallery_opened = false;
            },
            openExtendedPlan: function() {
                window.scrollTo(0, 0);
                this.extended_plan_opened = true;
            },
            closeExtendedPlan: function() {
                this.extended_plan_opened = false;
            },

     
        },

        mounted() {
            //  this.hasGallery();
            //    this.loadRelated();


        },
        watch: {

        },

        beforeMount() {

        },

        components: {
            TheIconClass,
            TheGettyUlan,
            TheCarousel,
            TheData,
            TheGallery,
            TheSimpleModal,
            ThePlanView,

        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .active_thumb {
        border: 4px solid #1e70bf
    }

    pre {
        overflow-x: auto;
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
    }

    .italic {
        font-style: italic;
    }

    .high {
        background-color: rgb(174, 223, 181)
    }

    .medium {
        background-color: rgb(255, 216, 179)
    }

    .low {
        background-color: #FFAAAA
    }
</style>



// WEBPACK FOOTER //
// src/components/TheItemView.vue